import moment from 'moment';

export const formatISOString = (date?: string | Date) => {
  return new Date(moment(date).format('YYYY-MM-DD')).toISOString();
};
